import { cn } from "@/lib/utils";
import { AnimatePresence, motion } from "motion/react";
import React, { PropsWithChildren } from "react";

type Props = {
  readonly value: React.ReactNode;
  readonly isVisible: boolean;
  readonly className?: string;
  readonly asHtml?: boolean;
};

export function BlurredValue(props: PropsWithChildren<Props>) {
  return (
    <AnimatePresence mode="wait">
      {props.isVisible ? (
        props.asHtml ? (
          <motion.div
            key={`value-${props.value}`}
            transition={{ delay: 0.3 }}
            initial={{ filter: "blur(2px)" }}
            animate={{ filter: "blur(0px)" }}
            className={cn(
              "text-md col-span-2 self-center whitespace-nowrap font-semibold",
              props.className,
            )}
            dangerouslySetInnerHTML={{ __html: props.value as string }}
          />
        ) : (
          <motion.div
            key={`value-${props.value}`}
            transition={{ delay: 0.3 }}
            initial={{ filter: "blur(2px)" }}
            animate={{ filter: "blur(0px)" }}
            className={cn(
              "text-md col-span-2 self-center whitespace-nowrap font-semibold",
              props.className,
            )}
          >
            {props.children ? props.children : props.value}
          </motion.div>
        )
      ) : (
        <motion.p
          key="value-hidden"
          transition={{ delay: 0.3 }}
          initial={{ filter: "blur(2px)" }}
          animate={{ filter: "blur(0px)" }}
          className={cn(
            "text-md col-span-2 self-center font-semibold",
            props.className,
          )}
        >
          ••••••
        </motion.p>
      )}
    </AnimatePresence>
  );
}
